import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { TaxDayApp } from './components/TaxDayApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import { OAuthCallback } from './pages/OAuthCallback';
import { Profile } from './pages/Profile';

function App() {
  return (
    <Routes>
      <Route path="/" element={<TaxDayApp />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/structure" element={<ProjectStructure />} />
      <Route path="/auth/callback" element={<OAuthCallback />} />
      <Route path="/profile" element={<Profile />} />
    </Routes>
  );
}

export default App;
